// test349
(349 && 0);
